// doc: https://stackoverflow.com/questions/44807468/where-to-put-user-id-in-a-ga-tracking-flow
import { prodAppHostName, apiPaths } from '../config'
import { getTimeDiffernce } from '../utils/index'

class Analytics {
  constructor(trackingAPI, shouldInitialized = false) {
    this.gaKey = ''
    this.shouldInitialized = shouldInitialized
    this.currentUser = {}
    this.ga = () => {}
    this.trackingAPI = trackingAPI
    this.pathWithTimestamp = {
      path: null,
      timestamp: '',
    }
    // const d = new Date()
    // this.date = d.getDate()
    // this.year = d.getFullYear()
  }

  initialize() {
    if (this.shouldInitialized) {
      this.ga('config', this.gaKey)
    }
  }

  setUser(user = {}) {
    this.currentUser = user
    if (this.shouldInitialized) {
      this.ga('config', this.gaKey, {
        user_id: this.currentUser.userId,
      })
      // ReactGA.set({ userId: this.currentUser.userId })
    }
  }

  setClinic(clinic = {}) {
    if (this.shouldInitialized) {
      this.currentUser.clinicId = clinic.id
      this.currentUser.clinicName = clinic.name
    }
  }

  timeStampUTC = () => {
    const now = new Date()
    const utcTimetamp = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds(),
    )
    return utcTimetamp
  }

  addZero = (i) => (i < 10 ? `0${i}` : i)

  stringify = (v) => (v instanceof Object ? JSON.stringify(v) : v)

  // getDateTime() {
  //   const d = new Date()
  //   const h = this.addZero(d.getHours())
  //   const m = this.addZero(d.getMinutes())
  //   const s = this.addZero(d.getSeconds())
  //   return `${this.date}-${this.year}T${h}:${m}:${s}`
  // }

  pageView(path) {
    const page = path.replace('#', '')
    if (this.shouldInitialized) {
      window.log('/path', path, this.currentUser)

      this.pageViewTrack(path, this.pathWithTimestamp.path)

      this.pathWithTimestamp.path = path
      this.pathWithTimestamp.timestamp = Date.now()

      // google analytics pageview
      this.ga('config', this.gaKey, {
        page_title: page,
        page_path: path,
      })
      // this.event({ action: 'rotuing', category: 'history', label: 'route', value: page })
    }
  }

  pageViewTrack(currentPath, previousPath) {
    const { userId, email, clinicName } = this.currentUser

    // sending current page event to the server
    this.eventAsync({
      action: 'pageview',
      category: 'pageview',
      label: 'location',
      value: this.stringify(currentPath),
      userId,
      email,
      created_at: this.timeStampUTC(),
      clinic: clinicName,
      unique_id: '',
      time_spent_in_mintues: 0,
    })

    // previous page with time spent sending to the server
    if (previousPath) {
      const { minutes, seconds } = getTimeDiffernce(this.pathWithTimestamp.timestamp)
      this.eventAsync({
        action: 'pageview',
        category: 'pageview',
        label: 'location',
        value: this.stringify(previousPath),
        userId,
        email,
        created_at: this.timeStampUTC(),
        clinic: clinicName,
        unique_id: '',
        time_spent_in_mintues: minutes,
        time_spent_in_seconds: seconds,
      })
    }
  }

  event({ action, category, label, value }) {
    if (this.shouldInitialized) {
      // window.log('GA Event: ', { action, category, label, value })

      // event fire for google analytcis
      this.ga('event', action, {
        event_category: category,
        event_label: label,
        value: this.stringify(value),
        // page_title: title,
        // page_path: path,
      })

      if (this.trackingAPI) {
        const { userId, email, clinicName } = this.currentUser
        const data = {
          action,
          category,
          label,
          value: this.stringify(value),
          userId,
          email,
          created_at: this.timeStampUTC(),
          clinic: clinicName,
          unique_id: '',
          time_spent_in_mintues: 0,
        }

        // event fire for our server tracking records
        this.eventAsync(data)
      }
    }
  }

  eventAsync(data) {
    window.log('API Call for Tracking Events: ', this.trackingAPI, data)
    // setTimeout(() => {
    //   const api =
    //     data instanceof Array
    //       ? this.trackingAPI.replace('_doc', '_bulk')
    //       : this.trackingAPI.replace('_bulk', '_doc')
    //   http
    //     .tracking(api, data, {})
    //     .then((res) => res)
    //     .catch((err) => err)
    // }, 2000)
  }
}

const {
  location: { hostname },
} = window
const shouldInitialized = hostname.includes(prodAppHostName)
const analytics = new Analytics(apiPaths.Clinic.tracking, shouldInitialized)

export default analytics

// Notes:
// * yes we can set userID not email as per google policy
// * we can not send public IP, but from dashboard we can see, which request comes from which region.
// * from analytics we cant figure out which user spends how much time on which page/route,
//    for that we need to create our own activity logs,
// * for now we are showing analytics, and after that we will try to save logs into our system,
//    for showing more details as per our requirements
